import { CommonSlideContent, CommonSlideContentClassName, HomepageSlide } from '../common';
import { FC } from 'react';
import { SwiperSlide } from 'swiper/react';
import { Motion } from './motion';
import cls from 'classnames';
import { EPageModule } from '~/utils/page-module';
import { useViewObserver } from '@lemon8/web-app-shared/util';
import { EClickPosition } from '~/utils/click-position';
import { useSloganLandscape } from './assets/slogan-landscape';
import { useSloganPortrait } from './assets/slogan-portrait';
import { useBtnPortrait } from './assets/btn-portrait';
import { activeToFeed } from '~/utils/active';

import './style.scss';

const PAGE_MODULE = EPageModule.INTERACT_INTRO;

export const InteractSlide: FC = () => {
  const SLOGAN_LANDSCAPE = useSloganLandscape();
  const SLOGAN_PORTRAIT = useSloganPortrait();
  const BTN_PORTRAIT = useBtnPortrait();

  const mobileDownloadRef = useViewObserver<HTMLImageElement>({
    onView: () => {
      window.Tea('wap_cta_show', {
        current_page_module: PAGE_MODULE,
        current_position: EClickPosition.INTERACT_BOTTOM_BUTTON,
      });
    },
  });

  const handleDownloadClick = (): void => {
    window.Tea('wap_click', {
      current_page_module: PAGE_MODULE,
      current_position: EClickPosition.INTERACT_BOTTOM_BUTTON,
      is_cta: 1,
    });
    activeToFeed({
      currentPosition: EClickPosition.INTERACT_BOTTOM_BUTTON,
    });
  };

  return (
    <HomepageSlide pageModule={PAGE_MODULE} className={cls('homepage-slide-interact', CommonSlideContentClassName)}>
      <Motion />
      <CommonSlideContent pageModule={PAGE_MODULE} />

      <img className="common-slogan-landscape" src={SLOGAN_LANDSCAPE} loading="lazy" />
      <img className="common-slogan-portrait" src={SLOGAN_PORTRAIT} loading="lazy" />
      <img
        className="common-download-bottom"
        src={BTN_PORTRAIT}
        ref={mobileDownloadRef}
        onClick={handleDownloadClick}
        loading="lazy"
      />
    </HomepageSlide>
  );
};

InteractSlide.displayName = SwiperSlide.displayName;
